import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

/* Bootstrap */
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
/* Bootstrap Icons */
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import "./assets/css/fonts.css";
import "./assets/css/style.css";

/* WOW.js */
import WOW from 'wowjs'

createApp(App).use(router).mount('#app')

new WOW.WOW({
  live: false
}).init()
